import { LucideIcon } from 'lucide-react'

interface FilterSectionProps {
  icon: LucideIcon
  label: string
  children: React.ReactNode
}

export function FilterSection({ icon: Icon, label, children }: FilterSectionProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 text-sm font-medium">
        <Icon className="w-4 h-4" />
        {label}
      </div>
      {children}
    </div>
  )
}
